
import { type } from '../../../shared/utility/utilityHelpers';
import { Action } from '@ngrx/store';
import { NavigationListModel } from '../navigation-model/navigation-list.model';

export const ActionTypes = {
    DO_NAVIGATION_LIST: type('[Navigation] Do NavigationList'),
    DO_NAVIGATION_LIST_SUCCESS: type('[Navigation] Do Navigation Success'),
    DO_NAVIGATION_LIST_FAIL: type('[Navigation] Do Navigation Fail'),
    DO_UPDATE_NAVIGATION_LIST_ACTION: type('[Navigation] Do Navigation List Update'),
    DO_UPDATE_NAVIGATION_LIST_SUCCESS: type('[Navigation] Do Navigation List Update Success'),
    DO_UPDATE_NAVIGATION_LIST_FAIL: type('[Navigation] Do Navigation List Update Fail'),
};

// Navigation LIST
export class DoNavigationListAction implements Action {
  type = ActionTypes.DO_NAVIGATION_LIST;

  constructor(public payload=null) { }
}

export class DoNavigationListSuccessAction implements Action {
  type = ActionTypes.DO_NAVIGATION_LIST_SUCCESS;

  constructor(public payload: any) {}
}

export class DoNavigationListFailAction implements Action {
  type = ActionTypes.DO_NAVIGATION_LIST_FAIL;

  constructor(public payload: any = null) {}
}

export class DoNavigationListUpdateAction implements Action {
  type = ActionTypes.DO_UPDATE_NAVIGATION_LIST_ACTION

  constructor(public payload: any) {}
}

export class DoNavigationListUpdateSuccessAction implements Action {
  type = ActionTypes.DO_UPDATE_NAVIGATION_LIST_SUCCESS;

  constructor(public payload: any) {}
}

export class DoNavigationListUpdateFailAction implements Action {
  type = ActionTypes.DO_UPDATE_NAVIGATION_LIST_FAIL;

  constructor(public payload: any = null) {}
}

export type Actions =
    | DoNavigationListAction
    | DoNavigationListSuccessAction
    | DoNavigationListFailAction
    | DoNavigationListUpdateAction
    | DoNavigationListUpdateFailAction
    | DoNavigationListUpdateSuccessAction
